import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { OAuthService } from 'angular-oauth2-oidc';

import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private oauthService: OAuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      /**
       * Will setup up silent refreshing for when the token is about to expire.
       * When the user is logged out via this.logOut method, the silent refreshing will pause and not refresh the tokens until the user is logged back
       * in via receiving a new token.
       */
      this.oauthService.setupAutomaticSilentRefresh();
      let url = document.location.href;
      this.authService.setFullUrl(url);

      const sessionId = this.getStripeSessionIdFromUrl();
      const status = this.getStripeStatusFromUrl();

      if (sessionId || status) {
        if (sessionId) {
          localStorage.setItem('sessionId', sessionId);
        }
        if (status) {
          localStorage.setItem('status', status);
        }
      }

      return true;
    } else {
      this.extractPartnerQueryParam();

      this.authService.login();

      return false;
    }
  }

  private getStripeSessionIdFromUrl(): string | null {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search.split('?')[1]);
    return urlParams.get('session_id');
  }

  private getStripeStatusFromUrl(): string | null {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search.split('?')[1]);
    return urlParams.get('status');
  }

  private extractPartnerQueryParam(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const partner = urlParams.get('utm_ref');

    if (partner) {
      localStorage.setItem('partner', partner);
    }
  }
}
